import '/src/scripts/_global';

import '/src/components/next/globals/navbar/navbar';
import '/src/components/next/blocks/feedback/feedback';
import '/src/components/next/blocks/contactus/contactus';

import { updateScrollOut } from '/src/scripts/es-modules/scroll-reveal';

import posts from '../requires/articles-news-more';

const button = document.querySelector('.js-load-more');

button.addEventListener(
  'click',
  () => {
    button.remove();

    document.querySelector('.posts').insertAdjacentHTML(
      'beforeend',
      posts.reduce((accumulator, item) => {
        const { url, img, date, title, readTime } = item;
        const [src] = img.split('.');

        return `${accumulator}
          <a
            href="${url}"
            class="post posts__item | wow wow_fade-up"
          >
            <picture class="post__thumb">
              <source
                type="image/webp"
                srcset="${src}.webp, ${src}@2x.webp 2x">
              <img
                alt=""
                src="${src}.jpg"
                class="post__thumb-src"
                srcset="${src}@2x.jpg 2x">
            </picture>

            <div class="post__body">
              <div class="post__title h4">${title}</div>

              <div class="post__date">
                ${date} · ${readTime} min read
              </div>
            </div>
          </a>
        `;
      }, ''),
    );

    updateScrollOut();
  },
  { once: true },
);
